{
  "agreements": {
    "title": "Соглашения",
    "listHeading": "Соглашения · {{count}}",
    "listHint": "Выберите соглашение — редактор справа.",
    "editingNow": "Сейчас редактируете",
    "creatingNow": "Новое соглашение",
    "empty": "Соглашений пока нет.",
    "newAgreement": "Новое соглашение",
    "systemBadge": "Системное",
    "inactiveBadge": "Выключено",
    "versionLabel": "Версия {{version}}",
    "acceptancesLabel": "Принятий: {{count}}",
    "pickHint": "Выберите соглашение слева или создайте новое.",
    "fields": {
      "key": "Ключ",
      "keyHint": "Уникальный идентификатор для кода. У системных соглашений не меняется.",
      "keyPlaceholder": "seedance_avatar_registration",
      "title": "Заголовок",
      "body": "Текст соглашения",
      "active": "Активно"
    },
    "systemKeyReadonly": "Публичный URL: /agreements/{{key}}. Ключ системного соглашения изменить нельзя.",
    "create": "Создать",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "delete": "Удалить",
    "deleteConfirm": "Удалить это соглашение? Действие необратимо.",
    "systemNoDelete": "Системное соглашение удалить нельзя."
  },
  "styleCatalog": {
    "headTitle": "Каталог стилей",
    "title": "Каталог стилей",
    "tabs": {
      "genres": "Жанры",
      "tones": "Нарративные тоны",
      "mediums": "Медиумы"
    },
    "mediumBaseImage": "Системная картинка-основа для превью медиумов",
    "noBaseImage": "Не загружена",
    "uploadBaseImage": "Загрузить",
    "deleteBaseImage": "Удалить",
    "deleteBaseImageConfirm": "Удалить системную картинку-основу?",
    "listTitle": "Список",
    "filterPlaceholder": "Поиск по названию…",
    "clearFilter": "Очистить фильтр",
    "add": "Добавить",
    "hidden": "скрыт",
    "creatingNow": "Создаёте новое",
    "editingNow": "Сейчас редактируете",
    "newItem": "Новая запись",
    "editItem": "Редактирование: {{label}}",
    "label": "Название",
    "category": "Раздел",
    "uncategorizedGroup": "Без раздела",
    "promptFragment": "Фрагмент промпта",
    "hiddenLabel": "Скрыть в выборе",
    "projectsUsing": "Проектов с этим значением: {{count}}",
    "generatePreview": "Сгенерировать превью",
    "deleteReferenceImage": "Удалить превью",
    "deleteReferenceImageConfirm": "Удалить превью этого медиума?",
    "imageProviderLabel": "Модель генерации",
    "dashscopeModelLabel": "Модель DashScope",
    "geminiModelLabel": "Модель Gemini",
    "openrouterModelLabel": "Модель OpenRouter",
    "noImageProviders": "Нет настроенных провайдеров генерации картинок (Studio → AI).",
    "generatingPreview": "Генерация превью… {{progress}}%",
    "save": "Сохранить",
    "delete": "Удалить",
    "renameConfirm": "Переименование затронет {{count}} проект(ов), у которых сохранено старое название. Продолжить?",
    "deleteConfirm": "Удалить «{{label}}»?"
  },
  "splashAnnouncements": {
    "title": "Объявления",
    "listHeading": "Объявления · {{count}}",
    "listHint": "Слайдер новостей и предложений на странице проектов.",
    "empty": "Объявлений пока нет.",
    "create": "Создать",
    "newAnnouncement": "Новое объявление",
    "creatingNow": "Создание",
    "editingNow": "Редактирование",
    "untitled": "Без названия",
    "pickHint": "Выберите объявление слева или создайте новое.",
    "meta": "Версия {{version}} · скрытий: {{dismissals}}",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "delete": "Удалить",
    "deleteConfirm": "Удалить объявление? Скрытия пользователей тоже будут удалены.",
    "publish": "Опубликовать",
    "unpublish": "Снять с публикации",
    "preview": "Превью",
    "previewNoTitle": "Заголовок объявления",
    "runtimeStatus": {
      "draft": "Черновик",
      "scheduled": "Запланировано",
      "live": "Показывается",
      "expired": "Истекло"
    },
    "audience": {
      "all": "Все компании",
      "selected": "Выбранные компании"
    },
    "presets": {
      "river_glass": "River glass",
      "violet_split": "Violet split",
      "cinematic": "Cinematic",
      "amber_signal": "Amber signal",
      "midnight_minimal": "Midnight minimal"
    },
    "blockers": {
      "title_ru_missing": "нет заголовка на русском",
      "title_en_missing": "нет заголовка на английском",
      "companies_missing": "не выбрана ни одна компания",
      "window_invalid": "окончание показа раньше начала"
    },
    "fields": {
      "titleRu": "Заголовок (RU)",
      "titleEn": "Заголовок (EN)",
      "bodyRu": "Текст (RU)",
      "bodyEn": "Текст (EN)",
      "ctaLabelRu": "Кнопка (RU)",
      "ctaLabelEn": "Кнопка (EN)",
      "ctaUrl": "Ссылка кнопки",
      "ctaUrlPlaceholder": "/projects/new или https://…",
      "ctaUrlHint": "Относительный путь внутри приложения или HTTPS-ссылка.",
      "stylePreset": "Стиль плашки",
      "position": "Порядок",
      "positionHint": "Меньше — раньше в слайдере.",
      "startsAt": "Начало показа",
      "endsAt": "Окончание показа",
      "audience": "Аудитория",
      "companySearch": "Поиск компании…",
      "companiesEmpty": "Компании не найдены.",
      "companiesSelected": "Выбрано компаний: {{count}}",
      "media": "Изображение или видео",
      "uploadMedia": "Загрузить медиа",
      "uploadPoster": "Постер видео",
      "removePoster": "Убрать постер",
      "removeMedia": "Убрать медиа",
      "mediaHint": "Изображение до 10 МБ или видео до 100 МБ. Без медиа используется фон выбранного стиля."
    }
  },
  "presentations": {
    "title": "Презентации",
    "defaultTitle": "Новая презентация",
    "create": "Создать презентацию",
    "createConfirm": "Создать",
    "search": "Поиск по названию…",
    "empty": "Презентаций пока нет.",
    "linkCopied": "Ссылка скопирована",
    "saving": "Сохранение…",
    "saveFailed": "Не удалось сохранить",
    "publishSettings": "Настройки публикации",
    "publicUrl": "Публичная ссылка",
    "pinEnabled": "Требовать PIN для просмотра",
    "pinPlaceholder": "4–8 цифр",
    "pinPrompt": "Введите PIN для просмотра презентации",
    "pinInvalid": "Неверный PIN",
    "pinSubmit": "Продолжить",
    "unavailableTitle": "Недоступно",
    "noSlides": "Нет слайдов для показа",
    "noSlideSelected": "Выберите слайд",
    "untitledSlide": "Без названия",
    "managedNote": "Слайды этой презентации собираются из presentations/{{slug}}/deck.yml. Правьте файл и запускайте bin/rails presentations:sync: правки здесь перезапишет следующая синхронизация.",
    "addSlide": "Добавить слайд",
    "hideSlide": "Скрыть слайд из просмотра",
    "deleteConfirm": "Удалить эту презентацию?",
    "deleteSlideConfirm": "Удалить этот слайд?",
    "enMissing": "Осталось пустых EN-полей: {{count}}",
    "menu": "Меню",
    "statusPublished": "Опубликована",
    "statusDraft": "Черновик",
    "columns": {
      "title": "Название",
      "status": "Статус",
      "updated": "Изменена",
      "slides": "Слайдов",
      "language": "Язык",
      "author": "Автор",
      "link": "Ссылка"
    },
    "fields": {
      "titleRu": "Название (RU)",
      "version": "Версия",
      "description": "Описание",
      "defaultLocale": "Язык по умолчанию"
    },
    "tabs": {
      "content": "Контент",
      "slide": "Слайд",
      "presentation": "Презентация"
    },
    "actions": {
      "edit": "Редактор",
      "preview": "Просмотр",
      "exportPdf": "Экспорт PDF",
      "downloadPdf": "Скачать PDF",
      "duplicate": "Дублировать",
      "publish": "Опубликовать",
      "unpublish": "Снять с публикации",
      "revokeLink": "Отозвать ссылку"
    },
    "export": {
      "title": "Экспорт презентации",
      "saveHint": "В диалоге печати выберите «Сохранить как PDF» в качестве принтера.",
      "rendering": "Готовим PDF…",
      "failed": "Не удалось подготовить PDF. {{error}}",
      "timeout": "Рендер идёт дольше пяти минут, попробуйте ещё раз.",
      "preparing": "Подготовка слайдов…"
    },
    "contentForm": {
      "title": "Заголовок",
      "subtitle": "Подзаголовок",
      "body": "Текст",
      "description": "Описание",
      "caption": "Подпись",
      "image": "Изображение",
      "video": "Видео",
      "leftImage": "Левое изображение",
      "rightImage": "Правое изображение",
      "leftCaption": "Подпись слева",
      "rightCaption": "Подпись справа",
      "imageN": "Изображение {{n}}",
      "screenshotN": "Скриншот {{n}}",
      "overlayTitle": "Текст поверх",
      "overlayPosition": "Позиция текста",
      "positionTop": "Сверху",
      "positionCenter": "По центру",
      "positionBottom": "Снизу",
      "beforeLabel": "Подпись «до»",
      "afterLabel": "Подпись «после»",
      "beforeImage": "Изображение «до»",
      "afterImage": "Изображение «после»",
      "beforeText": "Текст «до»",
      "afterText": "Текст «после»",
      "autoplay": "Автовоспроизведение",
      "loop": "Зациклить",
      "muted": "Без звука",
      "date": "Дата",
      "value": "Значение",
      "label": "Подпись метрики",
      "itemsSection": "Пункты списка",
      "featuresSection": "Функции",
      "stepsSection": "Шаги",
      "metricsSection": "Метрики",
      "itemCount": "{{count}} шт.",
      "itemN": "Пункт {{n}}",
      "featureN": "Функция {{n}}",
      "stepN": "Шаг {{n}}",
      "metricN": "Метрика {{n}}",
      "addItem": "Добавить пункт",
      "addStep": "Добавить шаг",
      "addMetric": "Добавить метрику",
      "removeItem": "Удалить",
      "moveUp": "Выше",
      "moveDown": "Ниже",
      "stepStatus": "Статус",
      "statusDone": "Завершён",
      "statusCurrent": "Текущий",
      "statusUpcoming": "Предстоящий"
    }
  },
  "systemPrompts": {
    "title": "Системные промпты",
    "noTemplates": "Нет шаблонов в базе.",
    "filterPlaceholder": "Поиск по названию…",
    "clearFilter": "Очистить поиск",
    "filterEmpty": "Ничего не найдено.",
    "status": {
      "new": "Новый",
      "update": "Обновление",
      "conflict": "Конфликт",
      "orphan": "Нет в коде"
    },
    "diff": {
      "showUnchanged_one": "Ещё {{count}} строка без изменений",
      "showUnchanged_few": "Ещё {{count}} строки без изменений",
      "showUnchanged_many": "Ещё {{count}} строк без изменений",
      "showUnchanged_other": "Ещё {{count}} строки без изменений",
      "noChanges": "Текст не меняется."
    },
    "upstream": {
      "title": "Обновления из кода",
      "subtitle": "Релиз принёс новые промпты и изменения. В базе ничего не меняется без вашего решения: до этого система работает на текущем тексте.",
      "pinnedHint": "Новых {{new}} · обновлений {{update}} · конфликтов {{conflict}}",
      "emptyTitle": "Всё синхронизировано",
      "emptyDescription": "Новых промптов, обновлений и конфликтов с кодом нет.",
      "conflict": {
        "title": "Конфликты",
        "hint": "Промпт поменяли и в базе, и в коде. Для каждого конфликта возьмите версию из базы, из кода или обе и при необходимости поправьте итог. Ассистент может заполнить итог за вас.",
        "baseUnknown": "Общий предок неизвестен",
        "count_one": "{{count}} конфликт",
        "count_few": "{{count}} конфликта",
        "count_many": "{{count}} конфликтов",
        "count_other": "{{count}} конфликта",
        "autoMerge": "Правки не пересекаются — проверьте автослияние",
        "resolve": "Разрешить"
      },
      "update": {
        "title": "Обновления без конфликтов",
        "hint": "В базе этот промпт с прошлого применения не правили — можно взять текст из кода.",
        "applyAll_one": "Применить {{count}} обновление",
        "applyAll_few": "Применить {{count}} обновления",
        "applyAll_many": "Применить {{count}} обновлений",
        "applyAll_other": "Применить {{count}} обновления",
        "showDiff": "Изменения",
        "loadingDiff": "Загрузка…",
        "apply": "Применить",
        "confirmTitle": "Применить обновления из кода?",
        "confirmMessage_one": "Текст {{count}} промпта в базе заменится на версию из кода. Прежний текст останется в истории версий.",
        "confirmMessage_few": "Тексты {{count}} промптов в базе заменятся на версии из кода. Прежние тексты останутся в истории версий.",
        "confirmMessage_many": "Тексты {{count}} промптов в базе заменятся на версии из кода. Прежние тексты останутся в истории версий.",
        "confirmMessage_other": "Тексты {{count}} промпта в базе заменятся на версии из кода. Прежние тексты останутся в истории версий."
      },
      "new": {
        "title": "Новые промпты",
        "hint": "Их ещё нет в базе: система берёт текст прямо из кода. После добавления промпт можно будет править в Studio.",
        "selectAll": "Выбрать все",
        "selectNone": "Снять выбор",
        "addSelected_one": "Добавить {{count}} промпт",
        "addSelected_few": "Добавить {{count}} промпта",
        "addSelected_many": "Добавить {{count}} промптов",
        "addSelected_other": "Добавить {{count}} промпта",
        "preview": "Текст",
        "confirmTitle": "Добавить промпты из кода?",
        "confirmMessage_one": "В базу добавится {{count}} промпт с текстом из кода.",
        "confirmMessage_few": "В базу добавятся {{count}} промпта с текстами из кода.",
        "confirmMessage_many": "В базу добавятся {{count}} промптов с текстами из кода.",
        "confirmMessage_other": "В базу добавятся {{count}} промпта с текстами из кода.",
        "add": "Добавить"
      }
    },
    "merge": {
      "save": "Сохранить",
      "saveAnyway": "Сохранить всё равно",
      "saveBlocked": "Сначала решите все конфликты",
      "progress": "Решено {{resolved}} из {{total}}",
      "noConflicts": "Конфликтов нет: правки слились автоматически.",
      "askAgent": "Предложить решение",
      "askingAgent": "Ассистент думает…",
      "agentDone_one": "Ассистент заполнил итог для {{count}} конфликта. Проверьте его перед сохранением.",
      "agentDone_few": "Ассистент заполнил итог для {{count}} конфликтов. Проверьте их перед сохранением.",
      "agentDone_many": "Ассистент заполнил итог для {{count}} конфликтов. Проверьте их перед сохранением.",
      "agentDone_other": "Ассистент заполнил итог для {{count}} конфликта. Проверьте его перед сохранением.",
      "agentPartial_one": "Для {{count}} конфликта ассистент не дал надёжного решения ({{reasons}}). Решите его вручную.",
      "agentPartial_few": "Для {{count}} конфликтов ассистент не дал надёжного решения ({{reasons}}). Решите их вручную.",
      "agentPartial_many": "Для {{count}} конфликтов ассистент не дал надёжного решения ({{reasons}}). Решите их вручную.",
      "agentPartial_other": "Для {{count}} конфликта ассистент не дал надёжного решения ({{reasons}}). Решите его вручную.",
      "agentReject": {
        "unknown_choice": "неизвестный вариант",
        "missing_text": "пустой ответ",
        "conflict_markers": "маркеры конфликта",
        "lost_placeholders": "пропали плейсхолдеры"
      },
      "mainField": "Основной текст",
      "facingField": "Ракурс {{facing}}",
      "auto": {
        "ours": "Из базы",
        "theirs": "Из кода",
        "both": "Совпало в базе и коде",
        "deleted": "(строки удалены)"
      },
      "take": "Взять",
      "takeAllOurs": "Взять базу везде",
      "takeAllTheirs": "Взять код везде",
      "showMore_one": "Ещё {{count}} строка",
      "showMore_few": "Ещё {{count}} строки",
      "showMore_many": "Ещё {{count}} строк",
      "showMore_other": "Ещё {{count}} строки",
      "customAria": "Итог конфликта {{number}}",
      "customPlaceholder": "Возьмите одну из версий или напишите итог сами. Пустое поле после правки уберёт эти строки.",
      "oursTitle": "В базе (ваша версия)",
      "theirsTitle": "Из кода (новый релиз)",
      "sideEmpty": "Строки удалены",
      "agentTitle": "Итог предложил ассистент",
      "lowConfidence": "проверьте"
    },
    "history": {
      "open": "История",
      "title": "История версий",
      "loading": "Загрузка…",
      "empty": "Версий пока нет.",
      "current": "текущая",
      "diffHint": "Выбранная версия → текущий текст в базе.",
      "restore": "Восстановить",
      "restoreTitle": "Восстановить версию?",
      "restoreMessage": "Текст промпта в базе заменится выбранной версией, включая промпты ракурсов. Текущий текст останется в истории.",
      "warnings_one": "{{count}} предупреждение",
      "warnings_few": "{{count}} предупреждения",
      "warnings_many": "{{count}} предупреждений",
      "warnings_other": "{{count}} предупреждения",
      "source": {
        "baseline": "Начальная версия",
        "code_new": "Добавлен из кода",
        "code_update": "Обновлён из кода",
        "manual": "Правка в Studio",
        "merge_manual": "Слияние вручную",
        "merge_agent": "Слияние с ассистентом",
        "restore": "Восстановлена версия"
      }
    },
    "editor": {
      "conflictNotice": "Код обновился, а этот промпт правили в базе — разрешите конфликт, иначе изменения релиза не попадут в работу.",
      "updateNotice": "В коде есть новая версия этого промпта — примените её или оставьте текущую.",
      "openMerge": "Открыть слияние"
    }
  },
  "facingEstablishing": {
    "sectionTitle": "Установочный кадр по ракурсу",
    "sectionHint": "Системные инструкции для генерации референса локации по ракурсу (3/4, вид сверху, север, юг, восток, запад).",
    "three_quarter": "3/4",
    "topview": "Вид сверху",
    "north": "Север",
    "south": "Юг",
    "east": "Восток",
    "west": "Запад",
    "empty": "—",
    "placeholder": "Оставьте пустым, чтобы использовать глобальный промпт"
  },
  "aiSettings": {
    "pageTitle": "Настройки AI API",
    "pageSubtitle": "Группы: Текст (ChatGPT через n8n), Картинки (GPT Image, Qwen Image, Wan 2.7 Image, OpenRouter, Google Gemini image, обложки и референсы), Видео (Kling, WAN, Seedance 2.0, Google Veo), Обработка (Topaz), плюс Сеть (исходящий HTTP-прокси). Секреты не показываются; оставьте поле ключа пустым, чтобы не менять сохранённое значение.",
    "headTitle": "Настройки AI API",
    "dashscopeEngineSummary": "Сториборд Qwen / Wan Image в проектах: {{summary}}",
    "navGroups": {
      "text": "Текст",
      "images": "Картинки",
      "video": "Видео",
      "postproduction": "Обработка",
      "network": "Сеть"
    },
    "currentlyEditing": "Сейчас настраиваете",
    "sectionsNavTitle": "Разделы",
    "sectionsNavHint": "Выберите блок — поля справа.",
    "saveSettings": "Сохранить настройки",
    "savingSettings": "Сохранение…",
    "common": {
      "webhookUrl": "Webhook URL",
      "authMode": "Режим авторизации",
      "tokenSecret": "Токен / секрет",
      "tokenSaved": "(уже сохранён)",
      "tokenNotSet": "(не задан)",
      "replaceTokenPlaceholder": "•••••••• — введите новый, чтобы заменить",
      "enterTokenPlaceholder": "Введите токен",
      "requestTimeoutSec": "Таймаут запроса (с)",
      "pollIntervalSec": "Интервал опроса (с)",
      "pollMaxAttempts": "Макс. попыток опроса",
      "apiKey": "API Key",
      "apiKeySaved": "(уже сохранён)",
      "apiKeyNotSet": "(не задан)",
      "apiKeyPlaceholder": "API Key из консоли Kling",
      "baseUrl": "Base URL",
      "baseUrlRegion": "Base URL (регион)",
      "defaultModel": "Модель по умолчанию",
      "defaultVideoModel": "Модель видео по умолчанию",
      "defaultModelVideo": "Модель по умолчанию (видео)",
      "enablePrefix": "Включить",
      "testUsesSavedHint": "Запрос уходит на сохранённые URL и токен. Чекбокс «Включить…» для проверки не обязателен; если меняли поля — сначала «Сохранить».",
      "testUsesSavedHintSaved": "сохранённые",
      "bearerHeaderOption": "Заголовок \"Bearer\" (как в n8n CAPAA)",
      "authorizationBearerOption": "Authorization: Bearer …",
      "accessKey": "Access Key",
      "accessKeySaved": "(уже сохранён)",
      "accessKeyNotSet": "(не задан)",
      "accessKeyPlaceholder": "Access Key из консоли Kling",
      "secretKey": "Secret Key",
      "secretKeySaved": "уже сохранён",
      "secretKeyNotSet": "не задан",
      "secretKeyReplacePlaceholder": "•••••••• — введите новый Secret Key, чтобы заменить",
      "secretKeyStorageHint": "В коде хранится в поле «секрет» (encrypt); показывается только в консоли Kling один раз.",
      "resolution": "Разрешение",
      "model": "Модель",
      "optional": "опционально",
      "systemPrompts": "Системных промптах",
      "providersTitle": "Провайдеры",
      "documentation": "Документация",
      "videoPollIntervalSec": "Интервал опроса видео (с)",
      "generateContentTimeoutSec": "Таймаут generateContent (с)",
      "extraGetRetriesLabel": "Доп. попытки GET при обрыве сети",
      "extraGetRetriesTitle": "Сколько раз повторить один запрос статуса задачи (GET /tasks) при SocketError, таймаутах и т.п.",
      "getRetryPauseLabel": "Пауза между повторами GET (с)",
      "httpProxyUrl": "URL HTTP-прокси",
      "providerOptions": {
        "klingImages": "Kling (картинки)",
        "chatgptImageN8n": "ChatGPT Image (n8n GPT Image)",
        "qwenImage": "Qwen Image",
        "wanImage": "Wan 2.7 Image",
        "openrouterNanoBanana": "OpenRouter (Nano Banana 2)",
        "googleGeminiImage": "Google Gemini (image)"
      }
    },
    "sections": {
      "n8n": {
        "navLabel": "ChatGPT (n8n)",
        "navHint": "webhook · токен",
        "bannerTitle": "ChatGPT через n8n",
        "bannerSubtitle": "Webhook для текстовой генерации: структура и шоты через ChatGPT. Токен и режим заголовка авторизации.",
        "postJsonHint": "POST JSON: prompt, system_prompt. Заголовок: Bearer (кастомный) или стандартный Authorization: Bearer.",
        "enableLabel": "Включить текстовую генерацию через n8n",
        "testButton": "Проверить n8n"
      },
      "n8n_prompt_improver": {
        "navLabel": "Улучшение промпта (n8n)",
        "navHint": "webhook · шоты",
        "bannerTitle": "Улучшение промпта через n8n",
        "bannerSubtitle": "Отдельный webhook для улучшения пользовательских промптов кадра и видео в шот-панели. Свой токен и режим авторизации.",
        "postJsonHint": "POST JSON: prompt (исходный текст), system_prompt (целевая модель генерации). Ответ — улучшенный текст промпта.",
        "enableLabel": "Включить улучшение промптов через n8n",
        "testButton": "Проверить webhook",
        "videoPromptRulesTitle": "Правила улучшения видеопромптов по провайдерам",
        "videoPromptRulesHint": "Текст подмешивается в system-prompt при kind=video. Выбирается по эффективному видео-провайдеру проекта (override → Platform Config → legacy-колонка).",
        "seedanceRulesLabel": "Seedance 2 (BytePlus / OpenRouter)",
        "seedanceRulesProvidersHint": "Провайдеры: byteplus_seedance_video, openrouter_video",
        "klingRulesLabel": "Kling",
        "klingRulesProviderHint": "Провайдер: kling",
        "wanRulesLabel": "WAN",
        "wanRulesProviderHint": "Провайдер: wan"
      },
      "gpt_image": {
        "navLabel": "GPT Image (n8n)",
        "navHint": "webhook · сториборд",
        "bannerTitle": "GPT Image через n8n",
        "bannerSubtitle": "Webhook для картинок сториборда через GPT Image. Токен и режим авторизации — общие с ChatGPT (раздел «Текст»).",
        "requestBodyHint": "Тело запроса: system_prompt, prompt, aspect_ratio (например 9:16). Ответ JSON с URL картинки. Токен и режим авторизации — общие с ChatGPT (раздел «Текст»).",
        "webhookUrlLabel": "Webhook URL (GPT Image)",
        "testButton": "Проверить GPT Image",
        "testHint": "Нужен хотя бы один шот в базе. Сначала сохраните URL и токен (в разделе «Текст → ChatGPT»)."
      },
      "dashscope_storyboard": {
        "navLabel": "Qwen / Wan Image (сториборд)",
        "navHint": "multimodal-generation",
        "bannerTitle": "Qwen / Wan Image: сториборд",
        "bannerSubtitle": "Два семейства моделей: Qwen Image и Wan 2.7 Image — разные параметры; до трёх референсов; API Alibaba Model Studio.",
        "intro": "Вертикальный кадр сториборда через POST …/api/v1/services/aigc/multimodal-generation/generation. Это не видео — настройки видео в пункте «WAN (видео)». В пайплайне до трёх публичных URL референсов (локация и образы героев). Ключ по умолчанию совпадает с WAN; отдельное поле ниже переопределяет его только для картинок. Сначала выберите семейство — Qwen Image и Wan 2.7 image — это разные линейки моделей и параметров. Документация: Qwen-Image API, Wan 2.7 image API.",
        "modelFamilyTitle": "Семейство модели",
        "qwenImageFamily": "Qwen Image",
        "wanImageFamily": "Wan 2.7 image (万相)",
        "specificModelLabel": "Конкретная модель (только выбранное семейство)",
        "optionalApiKeyLabel": "Отдельный API Key для сториборда (опционально)",
        "optionalApiKeySaved": "— уже сохранён",
        "optionalApiKeyNotSet": "— не задан",
        "optionalApiKeyEmptyPlaceholder": "Пусто — используется ключ WAN",
        "wanSectionHint": "Base URL и таймаут HTTP — в разделе «WAN (видео)». Сохраните настройки перед проверкой.",
        "testButton": "Проверить Qwen / Wan Image",
        "testHint": "Реальный запрос к выбранной модели; не нажимайте часто из‑за квоты и стоимости."
      },
      "openrouter": {
        "navLabel": "OpenRouter",
        "navHint": "Nano Banana · Seedance",
        "bannerTitle": "OpenRouter (картинки и видео)",
        "bannerSubtitle": "Универсальный шлюз: картинки (Nano Banana 2 / Gemini 3.1 Flash) и видео (Seedance 2.0). Один API key — много моделей; выбор модели и разрешения — в настройках проекта.",
        "intro": "Единый API-шлюз openrouter.ai: один ключ — картинки и видео. Картинки: Nano Banana 2 (Gemini 3.1 Flash Image Preview). Видео: Seedance 2.0 (ByteDance) — модель и разрешение выбираются в настройках проекта.",
        "enableLabel": "Включить OpenRouter",
        "projectsOverrideModelHint": "Проекты могут переопределять модель в своих настройках.",
        "videoSectionTitle": "Видео через OpenRouter",
        "videoSectionHint": "Доступные модели: {{models}}. Разрешения: {{resolutions}}. Модель и разрешение задаются на уровне проекта (Настройки → Модели API → Видео → «Seedance 2.0 (OpenRouter)»). Используется тот же API key и Base URL, что и для картинок.",
        "apiKeyPlaceholder": "sk-or-… из openrouter.ai/keys",
        "videoPollTimeout": "Таймаут видео = {{seconds}}с ({{minutes}} мин)",
        "testButton": "Проверить OpenRouter",
        "testHint": "Реальный запрос к выбранной модели через OpenRouter. Сначала сохраните ключ."
      },
      "covers": {
        "navLabel": "Обложки и референсы",
        "navHint": "cover · character_reference",
        "bannerTitle": "Обложки и референс-листы героев",
        "bannerSubtitle": "Постер 16:9 и лист персонажа — Kling, n8n GPT Image, Qwen / Wan Image или OpenRouter; ключ и base URL — в разделе провайдера.",
        "intro": "После утверждения истории в обзоре проекта в фоне генерируется постер 16:9: Kling, webhook GPT Image (n8n) или Qwen Image или Wan 2.7 Image (те же модели, что и для сториборда; в production к постеру можно приложить URL референс-листа первого героя).",
        "coverProviderLabel": "Провайдер обложки",
        "coverModelLabel": "Модель для обложки",
        "coverDashscopeHint": "API и ключ — в разделе навигации «Qwen / Wan Image: сториборд». Для Qwen задаётся горизонтальный size 16:9.",
        "fallbackCoverPromptLabel": "Запасной системный промпт обложки (если пусто в Системных промптах)",
        "fallbackCoverPromptHintBefore": "Основной текст постера — в",
        "fallbackCoverPromptHintAfter": "(ключ project_cover). Сюда пишите только если там поле пустое: в запрос добавляются название, жанр, тон и фрагмент истории.",
        "characterReferenceTitle": "Референс-лист героя (16:9)",
        "characterReferenceIntroBefore": "Генерация с воркспейса «Герои». Системный текст задаётся в",
        "characterReferenceIntroAfter": "(ключ character_reference_sheet). Учётные данные — как у обложки: Kling, GPT Image (n8n) или Qwen / Wan Image.",
        "characterReferenceProviderLabel": "Провайдер референса героя",
        "characterReferenceModelLabel": "Модель для референс-листа",
        "klingOutfitsTitle": "Kling: образы героя (image2image)",
        "klingOutfitsHint": "Параметры для image2image при генерации образов (смена одежды/аксессуаров). Проекты наследуют эти значения, если не задали свои.",
        "klingOutfitsModelLabel": "Модель Kling для образов",
        "klingOutfitsModelHint": "kling-v1-5 — единственная модель, поддерживающая image_fidelity и image_reference. Пусто = kling-v1-5.",
        "klingOutfitsFidelityLabel": "image_fidelity образов",
        "klingOutfitsFidelityHint": "0..1. Чем выше — тем строже сохраняются черты лица и телосложение. По умолчанию 0.6.",
        "locationReferenceTitle": "Референс локации (16:9)",
        "locationReferenceIntroBefore": "Генерация с воркспейса «Локации». Системный текст задаётся в",
        "locationReferenceIntroAfter": "(ключи location_three_quarter_reference / location_topview_reference / location_reference_sheet / location_variant_reference). Учётные данные — общие: Kling, GPT Image (n8n) или Qwen / Wan Image.",
        "locationReferenceProviderLabel": "Провайдер референса локации",
        "locationReferenceModelLabel": "Модель для референса локации",
        "klingVariantModelLabel": "Kling: модель для image2image вариантов",
        "klingVariantModelHint": "Применяется только при провайдере Kling. Пусто = kling-v1-5: только эта модель реально слушает image_fidelity на endpoint /v1/images/generations. На kling-v2 параметр игнорируется, и вариант фактически генерируется из текста (теряются геометрия и планировка). На kling-v1-5 при image2image API всегда требует image_reference — мы шлём subject: при высоком image_fidelity он удерживает геометрию сцены, а пользовательский промпт меняет освещение / погоду / время суток.",
        "klingVariantFidelityLabel": "Kling: image_fidelity вариантов локации",
        "klingVariantFidelityHint": "Насколько строго придерживаться базового референса локации (0 — свободно, 1 — максимально точно). Для удержания геометрии сцены рекомендуем 0.8–0.9."
      },
      "kling": {
        "navLabel": "Kling AI",
        "navHint": "document API",
        "bannerTitle": "Kling AI",
        "bannerSubtitle": "Официальный API: text2video, image2video, generations. API Key или legacy JWT (Access + Secret Key). Модель изображений используется для обложек и референсов.",
        "apiIntro": "Официальный API Kling AI: Authorization: Bearer с единым API Key (рекомендуется) или legacy JWT из Access Key + Secret Key. Документация: kling.ai/document-api. Запросы: POST /v1/videos/text2video / POST /v1/videos/image2video, статус GET …/{task_id}; изображения: POST /v1/images/generations.",
        "authModeLabel": "Аутентификация",
        "authModeApiKey": "API Key (рекомендуется)",
        "authModeJwt": "Access Key + Secret Key (legacy JWT)",
        "authModeHint": "Новые ключи Kling — единый API Key. Старые аккаунты могут использовать пару Access Key + Secret Key.",
        "enableLabel": "Включить Kling API",
        "defaultImageModelLabel": "Модель изображений для обложек / референсов (опционально)",
        "testButton": "Проверить Kling (создать text2video)",
        "testHint": "Каждая проверка создаёт реальную задачу у Kling. Частые нажатия дают HTTP 429 (лимит запросов) — подождите несколько минут."
      },
      "wan": {
        "navLabel": "WAN (видео)",
        "navHint": "video-synthesis",
        "bannerTitle": "WAN (видео)",
        "bannerSubtitle": "i2v / r2v по модели; async API Alibaba Model Studio; публичный URL сториборда.",
        "intro": "Alibaba Model Studio: API Key в Authorization: Bearer, заголовок X-DashScope-Async: enable. Документация: 参考生视频 API. Для моделей с i2v в id (например wan2.6-i2v-flash) уходит image-to-video: input.img_url и обычный видеопромпт. Для r2v — ещё и reference_urls и префикс character1 в тексте. URL сториборда шота должен быть публичным HTTPS.",
        "enableLabel": "Включить WAN",
        "modelModeHint": "r2v — с референсами героев/локаций; i2v — только стартовый кадр",
        "apiKeyPlaceholder": "sk-… из консоли Model Studio",
        "getRetriesHint": "Повторы действуют только на опрос статуса (GET), не на создание задачи (POST) — чтобы не плодить дубли в WAN.",
        "testButton": "Проверить WAN (создать тестовую задачу video-synthesis)",
        "testHint": "Создаётся реальная задача в Alibaba Model Studio (публичная демо-картинка из документации). Не нажимайте часто — учитывайте квоту и стоимость."
      },
      "byteplus_seedance": {
        "navLabel": "BytePlus Seedance",
        "navHint": "ModelArk · Dreamina 2.0",
        "bannerTitle": "BytePlus ModelArk — Seedance 2.0",
        "bannerSubtitle": "Прямой Ark API (регион ap-southeast): POST /api/v3/contents/generations/tasks; референсы изображений и видео, first/last frame. Ключ: console.byteplus.com → ModelArk → API keys.",
        "intro": "Официальный BytePlus ModelArk — Video generation API. Base URL без /api/v3 (по умолчанию https://ark.ap-southeast.bytepluses.com). Модель и разрешение для проектов — в настройках workspace (видео → Seedance 2.0 BytePlus).",
        "enableLabel": "Включить BytePlus Seedance (ModelArk)",
        "resolutionsHint": "Разрешения: {{resolutions}}.",
        "apiKeyPlaceholder": "ARK API key из BytePlus ModelArk",
        "pollTimeoutApprox": "Таймаут опроса ≈ {{seconds}}с",
        "assetLibraryTitle": "Библиотека ассетов (Private Avatar)",
        "assetLibraryHint": "Отдельная подпись запросов AK/SK (SigV4). Используется для регистрации персонажей и образов как виртуальных ассетов Seedance.",
        "assetBaseUrl": "Base URL библиотеки ассетов",
        "assetRegion": "Регион",
        "assetProjectName": "Project name",
        "assetAccessKeyId": "Access Key ID",
        "assetSecretAccessKey": "Secret Access Key"
      },
      "google_ai_studio": {
        "navLabel": "Google AI Studio",
        "navHint": "Gemini image · Veo",
        "bannerTitle": "Google AI Studio (Gemini / Veo)",
        "bannerSubtitle": "Один API key и base URL (Gemini API): картинки через generateContent с responseModalities IMAGE; видео через Veo (predictLongRunning и опрос операции).",
        "docsIntro": "Документация: ai.google.dev/gemini-api. Ключ и base URL — из Google AI Studio; заголовок x-goog-api-key. Модели по умолчанию можно переопределить в настройках проекта.",
        "enableLabel": "Включить Google AI Studio (Gemini image + Veo)",
        "apiKeyPlaceholder": "Ключ из Google AI Studio",
        "geminiImageSection": "Gemini (изображения)",
        "testGeminiButton": "Проверить Gemini image",
        "testGeminiHint": "Реальный запрос generateContent; учитывайте квоту. Сохраните ключ перед проверкой.",
        "veoSection": "Veo (видео)",
        "testVeoButton": "Проверить Veo (только создание операции)",
        "testVeoHint": "Отправляет predictLongRunning без полного опроса и скачивания MP4."
      },
      "gemini_video_transcription": {
        "navLabel": "Расшифровка аниматика",
        "navHint": "Gemini 2.5 Pro · transcription",
        "bannerTitle": "Расшифровка сегментов аниматика (Gemini 2.5 Pro)",
        "bannerSubtitle": "Анализ видео-сегментов аниматика через Gemini 2.5 Pro: извлечение композиции, действий, диалогов, камеры. Использует тот же base URL (Google AI Studio); отдельный ключ или fallback на общий.",
        "intro": "Gemini 2.5 Pro анализирует короткий видео-сегмент аниматика (со звуком) и возвращает структурированный JSON: композиция, камера, действия, диалоги, заметки для промптов. Base URL и прокси — общие с Google AI Studio. Можно задать отдельный API key; если пуст — используется ключ Google AI Studio (fallback).",
        "enableLabel": "Включить расшифровку сегментов аниматика",
        "separateApiKeyLabel": "Отдельный API Key",
        "separateApiKeyNotSetFallback": "(не задан — fallback на общий Google AI Studio)",
        "separateApiKeyEmptyPlaceholder": "Пусто — используется ключ Google AI Studio",
        "fallbackKeyInUse": "Используется общий ключ Google AI Studio (fallback)",
        "testButton": "Проверить конфигурацию",
        "testHint": "Проверяет только валидность конфига (наличие ключа, base URL). Реальный запрос к API не выполняется."
      },
      "topaz_post_production": {
        "navLabel": "Topaz",
        "navHint": "улучшение видео",
        "bannerTitle": "Topaz Labs API — обработка",
        "bannerSubtitle": "AI-улучшение и апскейл видео через Topaz Labs. Семейства моделей и API-версии хранятся в каталоге обработки.",
        "intro": "Video API Topaz Labs использует X-API-Key и асинхронный flow: создать запрос, принять/upload, завершить upload, затем опрашивать статус. Каталог хранит схемы параметров семейства Proteus; здесь хранятся настройки подключения и polling.",
        "enableLabel": "Включить обработку через Topaz",
        "baseUrlHint": "Храним корневой URL. Будущий клиент добавит /video/ и request-specific пути.",
        "apiKeyPlaceholder": "API key из account.topazlabs.com/manage-api",
        "apiKeyHint": "Отправляется как X-API-Key. Значение шифруется и не возвращается в браузер.",
        "retryHint": "Документация Topaz рекомендует повторять запросы после HTTP 429 с backoff. Эти значения нужны будущим upload/status вызовам.",
        "noTestHint": "Кнопки проверки пока нет: quickstart flow создаёт реальный request и требует загрузки видеофайла."
      },
      "outbound_proxy": {
        "navLabel": "Исходящий прокси",
        "navHint": "HTTP → sing-box / VLESS",
        "bannerTitle": "Прокси для вызовов AI API",
        "bannerSubtitle": "HTTP(S) mixed (например sing-box в Kamal: http://sing-box:7890). Включается отдельно для каждого провайдера. Vless:// задаётся только в секретах контейнера sing-box, не здесь.",
        "intro": "Укажите HTTP или HTTPS прокси (CONNECT для исходящих HTTPS). В продакшене с Kamal accessory sing-box обычно http://sing-box:7890. Затем отметьте провайдеров, чьи запросы должны идти через прокси.",
        "testProxyHintBefore": "Кнопка ниже использует",
        "testProxyHintSaved": "уже сохранённые",
        "testProxyHintAfter": "в базе URL прокси. После правки поля сначала «Сохранить настройки». Запрос идёт на api.ipify.org — в ответе публичный IP исхода; сравните его с IP вашего выходного узла (VLESS). Если IP совпадает с IP сервера без туннеля — прокси не используется.",
        "testProxyButton": "Проверить прокси (внешний IP)",
        "proxyProviders": {
          "n8nChatgpt": "n8n ChatGPT (текст)",
          "n8nGptImage": "n8n GPT Image",
          "kling": "Kling",
          "wan": "WAN (видео DashScope)",
          "dashscopeMultimodal": "DashScope картинки (Qwen / Wan multimodal)",
          "openrouter": "OpenRouter",
          "byteplusSeedance": "BytePlus Seedance (ModelArk)",
          "googleAiStudio": "Google AI Studio (Gemini + Veo)",
          "topaz": "Topaz Labs"
        }
      }
    }
  },
  "generationModels": {
    "index": {
      "title": "Реестр моделей",
      "create": "Добавить модель",
      "providerConnections": "Подключения провайдеров",
      "empty": "Модели не найдены. Запустите it2tv:generation_models:sync.",
      "search": "Поиск по названию или ключу…",
      "searchEmpty": "По запросу ничего не найдено.",
      "filters": {
        "mediaKind": "Тип медиа",
        "usageContext": "Контекст",
        "active": "Статус",
        "all": "Все",
        "activeOnly": "Только активные",
        "inactiveOnly": "Только неактивные"
      },
      "table": {
        "displayName": "Название",
        "key": "Ключ",
        "mediaKind": "Тип",
        "routes": "Маршруты",
        "status": "Статус"
      },
      "status": {
        "active": "Активна",
        "inactive": "Выключена"
      },
      "platformHints": {
        "coverDashscope": "API и ключ — в Подключения провайдеров → DashScope. Для Qwen задаётся горизонтальный размер 16:9.",
        "klingOutfitsModel": "kling-v1-5 — единственная модель с image_fidelity и image_reference. Пусто = kling-v1-5.",
        "klingOutfitsFidelity": "0..1. Выше — строже сохранение лица и тела. По умолчанию 0.6.",
        "klingVariantModel": "Только при провайдере Kling. Пусто = kling-v1-5: только эта модель учитывает image_fidelity на /v1/images/generations.",
        "klingVariantFidelity": "Насколько строго следовать базовому референсу локации (0 — свободно, 1 — максимум). Для геометрии сцены рекомендуем 0.8–0.9."
      }
    },
    "show": {
      "back": "← К списку моделей",
      "editingNow": "Сейчас редактируете",
      "saving": "Сохранение…",
      "sections": {
        "details": "Параметры модели",
        "usages": "Контексты использования",
        "routes": "Маршруты к провайдерам"
      },
      "fields": {
        "displayName": "Отображаемое имя",
        "family": "Семейство",
        "position": "Порядок",
        "active": "Активна",
        "max_image_parts": "Макс. изображений-референсов",
        "max_video_refs": "Макс. видео-референсов",
        "max_audio_refs": "Макс. аудио-референсов",
        "max_video_ref_seconds": "Макс. секунд на видео-референс",
        "max_audio_ref_seconds": "Макс. секунд на аудио-референс",
        "max_total_video_ref_seconds": "Макс. суммарно секунд видео-референсов",
        "max_total_audio_ref_seconds": "Макс. суммарно секунд аудио-референсов"
      },
      "capabilities": {
        "title": "Дополнительные параметры",
        "durations": "Длительности (сек)",
        "addDuration": "Добавить",
        "removeDuration": "Удалить {{duration}} с",
        "aspectRatios": "Соотношения сторон",
        "addAspectRatio": "Добавить",
        "removeAspectRatio": "Удалить {{ratio}}",
        "extraParams": "Дополнительные параметры",
        "addParam": "Добавить параметр",
        "removeParam": "Удалить",
        "newParam": "Новый параметр",
        "paramKey": "Ключ",
        "paramKind": "Тип",
        "paramOptions": "Варианты",
        "paramOptionsPlaceholder": "4K",
        "addOption": "Добавить",
        "removeOption": "Удалить {{option}}",
        "paramDefault": "Значение по умолчанию",
        "emptyDefault": "Не задано",
        "enabledByDefault": "Включено по умолчанию",
        "kindSelect": "Список",
        "kindBoolean": "Да/нет",
        "kindNumber": "Число",
        "noExtraParams": "Нет дополнительных параметров",
        "metadataGroup": "Группа в каталоге",
        "metadataGroupPlaceholder": "Qwen Image"
      },
      "routes": {
        "active": "Активный маршрут",
        "activate": "Сделать активным"
      }
    },
    "usageContexts": {
      "canvas_image": "Изображение на холсте",
      "canvas_video": "Видео на холсте",
      "storyboard": "Сториборд",
      "shot_video": "Видео кадра",
      "location_reference": "Референс локации",
      "character_reference": "Референс персонажа",
      "character_outfit": "Образ персонажа",
      "cover": "Обложка",
      "storyboard_correction": "Корректировка кадра",
      "video_correction": "Корректировка видео",
      "transcription": "Транскрипция",
      "post_production": "Обработка",
      "voice_tts": "TTS голосов",
      "audio_transcription": "Транскрипция аудио",
      "voice_creation": "Создание голоса",
      "voice_sts": "Преобразование голоса",
      "agent": "Агент",
      "lipsync": "Липсинк",
      "sketch": "Корректировка эскиза",
      "previz_depth": "Маска глубины превиза"
    },
    "origin": {
      "catalog": "каталог",
      "studio": "Studio"
    },
    "new": {
      "title": "Новая модель",
      "eyebrow": "Подключение к провайдеру",
      "hint": "Модель появится в пикерах после сохранения. Нестандартное поведение API из полей не выводится.",
      "clone": {
        "label": "Скопировать с существующей модели",
        "placeholder": "Выберите модель для предзаполнения…",
        "hint": "Перед сохранением смените ключ, имя и wire-код, иначе будет конфликт с исходной моделью."
      },
      "saving": "Создание…",
      "submit": "Создать модель",
      "fields": {
        "key": "Ключ реестра",
        "provider": "Провайдер",
        "integration": "Интеграция",
        "wireCode": "Wire-код провайдера",
        "wireCodeHint": "Именно этот код уйдёт в API. Он может отличаться от ключа реестра.",
        "familyHint": "seedance — токены и обязательная строка video_input; kling — обязательные строки audio в себестоимости и в тарифе, если тариф задан числами.",
        "grantAllowlist": "Выдать компаниям с ограничениями доступа"
      },
      "billing": {
        "title": "Ставки (обязательно)",
        "hint": "Себестоимость USD обязательна (fallback без разрешения). GPL копируется с клона в новые строки этой модели. Пустой GPL нельзя: впишите цену или выберите бесплатно (0 ₽).",
        "familyVariants": "Для этого семейства нужна заполненная строка {{variant}}.",
        "cost": "Себестоимость USD",
        "tariff": "Тариф GPL, RUB",
        "tariffMode": "GPL",
        "tariffModeCustom": "Задать тариф",
        "tariffModeFree": "Бесплатно (0 ₽)",
        "tariffFreeHint": "При сохранении создадутся новые строки GPL с ценой 0 ₽. Исходная модель не меняется.",
        "resolutionAny": "разрешение (пусто = any)",
        "variant": "вариант",
        "addCost": "Добавить себестоимость",
        "addTariff": "Добавить тариф",
        "removeRow": "Удалить"
      }
    }
  },
  "integrationPlatform": {
    "title": "Настройки платформы",
    "sectionsHeading": "Цели генерации",
    "sectionsHint": "Выберите сущность — настройки моделей и поля платформы справа.",
    "filterPlaceholder": "Поиск по названию…",
    "clearFilter": "Очистить поиск",
    "filterEmpty": "Ничего не найдено.",
    "editingNow": "Сейчас редактируете",
    "defaultModel": "По умолчанию (из семейства сториборда)",
    "targetGroups": {
      "text": "Текст",
      "image": "Изображения",
      "video": "Видео",
      "audio": "Звук",
      "processing": "Обработка",
      "system": "Системное"
    },
    "targets": {
      "promptImprover": {
        "title": "Правила улучшения видеопромптов",
        "description": "Текстовые правила для провайдеров видео, которые уже используются prompt improver pipeline."
      },
      "agent": {
        "description": "Модель чата по умолчанию для ассистента проекта.",
        "reasoningEffortLabel": "Глубина reasoning",
        "reasoningEffortHint": "Управляет deep thinking GLM у всех ассистентов. Ниже — быстрее; выше — точнее в сложных тулах и промптах.",
        "reasoningEffortOptions": {
          "disabled": "Выкл — быстрее всего, без цепочки рассуждений",
          "high": "High — баланс (по умолчанию)",
          "max": "Max — самый глубокий reasoning, медленнее"
        }
      },
      "agentTools": {
        "title": "Инструменты ассистента",
        "description": "Включение и выключение инструментов ассистента проекта, а также выбор действий, которые требуют подтверждения в интерфейсе.",
        "navHint": "Вкл / подтверждение",
        "toolColumn": "Инструмент",
        "enabledColumn": "Включён",
        "confirmColumn": "Подтверждение",
        "modes": {
          "shots_assistant": "Шоты",
          "characters_assistant": "Герои",
          "locations_assistant": "Локации",
          "props_assistant": "Реквизит",
          "canvas_assistant": "Холст",
          "skills_discussion_assistant": "Скиллы: обсудить",
          "skills_editor_assistant": "Скиллы: редактировать",
          "skills_assistant": "Скиллы",
          "script_assistant": "Сценарий",
          "projects_assistant": "Проекты студии",
          "tasks_assistant": "Задачи",
          "scene3d_assistant": "3D-сцены",
          "notes": "Заметки"
        },
        "tools": {
          "improve_prompt": "Улучшить промпт шота",
          "update_shot_duration": "Изменить длительность шота",
          "regenerate_keyframe": "Перегенерировать кейфрейм",
          "regenerate_video": "Перегенерировать видео",
          "generate_project_cover": "Сгенерировать обложку проекта",
          "create_next_shot": "Создать следующий шот",
          "create_shots_batch": "Создать пачку шотов",
          "create_transition_shot": "Создать переходный шот",
          "create_character": "Создать героя",
          "update_character": "Обновить героя",
          "delete_character": "Удалить героя",
          "create_outfit": "Создать образ",
          "update_outfit": "Обновить образ",
          "generate_character_reference": "Сгенерировать референс героя",
          "generate_character_sheet": "Сгенерировать лист персонажа",
          "generate_character_emotion_sheet": "Сгенерировать лист эмоций",
          "generate_character_portrait": "Сгенерировать портрет",
          "generate_character_scale_pose": "Сгенерировать позу масштаба",
          "generate_character_media": "Сгенерировать медиа героя",
          "register_seedance_avatar": "Зарегистрировать аватар Seedance",
          "create_location": "Создать локацию",
          "update_location": "Обновить локацию",
          "delete_location": "Удалить локацию",
          "generate_location_reference": "Сгенерировать референс локации",
          "create_prop": "Создать реквизит",
          "update_prop": "Обновить реквизит",
          "delete_prop": "Удалить реквизит",
          "extract_props_from_script": "Извлечь реквизит из сценария",
          "generate_prop_reference": "Сгенерировать референс реквизита",
          "generate_prop_front_view": "Сгенерировать вид спереди реквизита",
          "update_canvas_prompt": "Обновить промпт холста",
          "set_canvas_media_kind": "Задать тип медиа холста",
          "update_canvas_settings": "Обновить настройки холста",
          "start_canvas_generation": "Запустить генерацию холста",
          "update_generation_skill": "Обновить скилл",
          "create_project": "Создать проект",
          "list_tasks": "Список задач",
          "get_task": "Прочитать задачу",
          "list_task_description_versions": "История описания задачи",
          "create_task": "Создать задачу",
          "update_task": "Обновить задачу",
          "list_task_assignees": "Список исполнителей задач",
          "list_task_mentionable_people": "Кого можно упомянуть в задачах",
          "add_task_comment": "Добавить комментарий к задаче",
          "update_task_comment": "Изменить свой комментарий к задаче",
          "attach_task_file": "Прикрепить файл задачи референсом",
          "propose_episode_script": "Предложить вариант сценария",
          "list_notes": "Список заметок",
          "get_note": "Прочитать заметку",
          "write_notes": "Создать или обновить заметки"
        }
      },
      "mcpTools": {
        "title": "Инструменты MCP",
        "description": "Включение и выключение методов, которые видят Claude и другие MCP-клиенты. Генерации по умолчанию выключены, пока суперадмин не включит их.",
        "navHint": "Вкл / выкл",
        "toolColumn": "Инструмент",
        "enabledColumn": "Включён",
        "groups": {
          "storyboard": "Сториборд",
          "canvas": "Холст",
          "entities": "Герои, локации, реквизит",
          "story": "Сценарий",
          "tasks": "Задачи",
          "notes": "Заметки",
          "generate": "Генерация шотов",
          "flow": "Флоу"
        },
        "tools": {
          "list_projects": "Список проектов",
          "list_shots": "Список шотов",
          "get_shot_prompts": "Прочитать промпты шота",
          "set_shot_prompt": "Записать промпт шота",
          "create_shot": "Создать шот",
          "create_transition_shot": "Создать шот-переход",
          "update_shot_intent": "Обновить описание шота",
          "list_canvas_boards": "Список досок холста",
          "list_canvas_generations": "Список генераций холста",
          "get_canvas_generation": "Прочитать генерацию холста",
          "get_canvas_prompt": "Прочитать черновик холста",
          "set_canvas_prompt": "Записать черновик холста",
          "generate_canvas": "Сгенерировать на холсте",
          "list_characters": "Список героев",
          "get_character": "Прочитать героя",
          "create_character": "Создать героя",
          "update_character": "Обновить героя",
          "list_locations": "Список локаций",
          "get_location": "Прочитать локацию",
          "create_location": "Создать локацию",
          "update_location": "Обновить локацию",
          "list_props": "Список реквизита",
          "get_prop": "Прочитать реквизит",
          "create_prop": "Создать реквизит",
          "update_prop": "Обновить реквизит",
          "get_story": "Прочитать сценарий",
          "update_story": "Обновить сценарий",
          "list_scenes": "Список сцен",
          "create_scene": "Создать сцену",
          "list_tasks": "Список задач",
          "get_task": "Прочитать задачу",
          "list_task_description_versions": "История описания задачи",
          "create_task": "Создать задачу",
          "update_task": "Обновить задачу",
          "list_task_assignees": "Список исполнителей задач",
          "list_task_mentionable_people": "Кого можно упомянуть в задачах",
          "add_task_comment": "Добавить комментарий к задаче",
          "update_task_comment": "Изменить свой комментарий к задаче",
          "generate_shot_storyboard": "Сгенерировать сториборд шота",
          "generate_shot_video": "Сгенерировать видео шота",
          "list_notes": "Список заметок",
          "get_note": "Прочитать заметку",
          "write_notes": "Создать или обновить заметки",
          "list_flow_boards": "Список досок флоу",
          "list_flow_nodes": "Список нод флоу",
          "get_flow_node": "Прочитать ноду флоу",
          "create_flow_board": "Создать доску флоу",
          "create_flow_node": "Создать ноду флоу",
          "update_flow_node": "Обновить ноду флоу",
          "remove_flow_node": "Убрать ноду флоу",
          "connect_flow_nodes": "Соединить ноды флоу",
          "disconnect_flow_edge": "Разъединить ноды флоу",
          "generate_flow_nodes": "Сгенерировать на флоу"
        }
      },
      "storyboard": {
        "description": "Модели для сториборда и опорных кадров шотов."
      },
      "cover": {
        "description": "Модели и platform defaults для генерации обложек проектов."
      },
      "characterReference": {
        "description": "Модели и defaults для референса персонажа."
      },
      "characterOutfit": {
        "description": "Модели и параметры генерации образа персонажа."
      },
      "locationReference": {
        "description": "Модели и defaults для референса локации."
      },
      "canvasImage": {
        "description": "Модели для генерации изображений на холсте."
      },
      "storyboardCorrection": {
        "description": "Модели для корректировки опорных кадров."
      },
      "sketch": {
        "description": "Модели для AI-корректировки в редакторе эскиза."
      },
      "shotVideo": {
        "description": "Модели для генерации видео шота."
      },
      "canvasVideo": {
        "description": "Модели для генерации видео на холсте."
      },
      "videoCorrection": {
        "description": "Модели для корректировки видео."
      },
      "previzDepth": {
        "description": "Модель для серой и цветной маски глубины превиза."
      },
      "transcription": {
        "description": "Модели для распознавания и транскрипции аниматиков."
      },
      "audioTranscription": {
        "description": "Модели для распознавания аудио дорожек и диалогов шотов."
      },
      "voiceCreation": {
        "description": "Модели для Voice Design, Remix и Instant Voice Cloning."
      },
      "voiceTts": {
        "description": "Модели TTS для превью голосов персонажей."
      },
      "postProduction": {
        "description": "Модели для улучшения, апскейла и другой обработки видео."
      },
      "outboundProxy": {
        "title": "Исходящий proxy",
        "description": "Системная настройка outbound proxy для генерации.",
        "providersTitle": "Провайдеры через прокси",
        "providersEmpty": "Нет глобальных подключений провайдеров."
      },
      "videoOutput": {
        "title": "Итоговые видео",
        "description": "FPS по умолчанию для нормализации видео после генерации или загрузки. Проект может наследовать или переопределить. Смена влияет на новые файлы.",
        "fpsLabel": "FPS итоговых файлов",
        "fpsHint": "Применяется при нормализации после генерации или загрузки. В Настройках проекта → Общие можно переопределить.",
        "fpsOption": "{{fps}} fps",
        "fpsValue": "{{fps}} fps"
      }
    },
    "modelRegistry": {
      "title": "Модели для выбранной цели",
      "hint": "Доступные модели и маршруты для «{{context}}».",
      "hintPrefix": "Доступные модели и маршруты для:",
      "openFilteredRegistry": "Открыть реестр",
      "openModel": "Карточка модели",
      "empty": "Для этой цели пока нет активных моделей в реестре.",
      "capabilities": "Возможности",
      "durations": "Длительности",
      "extraParams": "Параметры",
      "noRoutes": "Маршруты для модели не настроены.",
      "connectionConfigured": "Подключение настроено",
      "connectionNotConfigured": "Подключение не настроено"
    },
    "modelSelection": {
      "title": "Модель для выбранной цели",
      "hintPrefix": "Выбранная модель отвечает за генерацию сущностей цели:",
      "fieldLabel": "Модель",
      "openFilteredRegistry": "Открыть реестр",
      "openModel": "Карточка модели",
      "empty": "Для этой цели пока нет активных моделей в реестре.",
      "capabilities": "Возможности",
      "durations": "Длительности",
      "extraParams": "Параметры",
      "activeRoute": "Активный маршрут провайдера",
      "noActiveRoute": "Активный маршрут не настроен. Выберите его в карточке модели или на странице «Провайдеры».",
      "connectionConfigured": "Подключение настроено",
      "connectionNotConfigured": "Подключение не настроено",
      "noModelSelected": "Модель не выбрана",
      "noModelTarget": "Без выбора модели"
    }
  },
  "providerConnections": {
    "index": {
      "title": "Подключения провайдеров",
      "creatingNow": "Создаёте новое",
      "editingNow": "Сейчас редактируете",
      "emptyList": "Подключений пока нет.",
      "create": "Создать",
      "filterPlaceholder": "Поиск по названию…",
      "clearFilter": "Очистить поиск",
      "filterEmpty": "Ничего не найдено.",
      "newTitle": "Новое подключение",
      "emptySelection": "Выберите подключение слева или создайте новое.",
      "confirmDelete": "Удалить это подключение?",
      "test": "Проверить",
      "checkBalance": "Проверить баланс",
      "routesCount": "Привязано маршрутов: {{count}}",
      "routes": {
        "title": "Маршруты",
        "summary": "Активных: {{active}} из {{total}}",
        "empty": "Маршрутов пока нет. Запустите it2tv:generation_models:sync или пересоздайте подключение.",
        "active": "Активен",
        "activate": "Активировать",
        "activateAll": "Активировать все"
      },
      "filters": {
        "providerKind": "Провайдер",
        "all": "Все"
      },
      "fields": {
        "providerKind": "Тип провайдера",
        "name": "Название",
        "priority": "Приоритет",
        "apiBaseUrl": "Base URL API",
        "enabled": "Включено",
        "proxyEnabled": "Через прокси",
        "tosMirrorEnabled": "Референсы через TOS",
        "notes": "Заметки"
      },
      "credentials": {
        "title": "Ключи",
        "configured": "Ключи заданы",
        "notConfigured": "Ключи не заданы",
        "apiKey": "API key",
        "storyboardApiKey": "API key для сториборда (опционально)",
        "transcriptionApiKey": "API key для транскрибации (опционально)",
        "accessKey": "Access key",
        "secretKey": "Secret key",
        "authValue": "Auth token",
        "authMode": "Аутентификация",
        "authModeApiKey": "API Key (рекомендуется)",
        "authModeJwt": "Access Key + Secret Key (legacy JWT)",
        "leaveBlank": "Оставьте пустым, чтобы не менять"
      },
      "balance": {
        "title": "Баланс",
        "unsupported": "Мониторинг баланса недоступен для этого провайдера.",
        "neverChecked": "Баланс ещё не проверялся.",
        "lastChecked": "Последняя проверка: {{date}}",
        "remaining": "Остаток",
        "spendingTitle": "Интенсивность расходования",
        "spendingUnavailable": "Недостаточно истории баланса (нужно минимум 2 проверки).",
        "spendPerDay": "~{{amount}} / день",
        "spendPerHour": "~{{amount}} / час",
        "daysRemaining": "~{{days}} дн. при текущем темпе",
        "checkFailed": "Последняя проверка не удалась: {{message}}",
        "klingDelayNote": "Остаток кредитов Kling может обновляться с задержкой до ~12 ч.",
        "byteplusDelayNote": "Данные биллинга BytePlus могут отставать до ~1 ч.",
        "byteplusSpentSinceSync": "Списано с синхронизации пакета: {{amount}} токенов",
        "byteplusConsumedMtd": "Списано за месяц",
        "byteplusMtdSpend": "Расход за месяц: {{amount}}",
        "units": {
          "usd": "${{amount}}",
          "credits": "{{amount}} кред.",
          "tokens": "{{amount}} токенов"
        }
      },
      "timing": {
        "title": "Таймауты и опрос"
      },
      "settings": {
        "title": "Опции провайдера",
        "webhookUrl": "Webhook URL",
        "authMode": "Режим авторизации",
        "authModeBearerHeader": "Заголовок Bearer (как в n8n CAPAA)",
        "authModeAuthorizationBearer": "Authorization: Bearer",
        "requestTimeoutSec": "Таймаут запроса (с)",
        "pollIntervalSec": "Интервал опроса (с)",
        "pollMaxAttempts": "Макс. попыток опроса",
        "videoPollIntervalSec": "Интервал опроса видео (с)",
        "veoPollIntervalSec": "Интервал опроса Veo (с)",
        "httpMaxRetries": "Доп. попытки GET",
        "httpRetryIntervalSec": "Пауза между повторами GET (с)",
        "byteplusAdminApiBaseUrl": "Base URL asset/admin API",
        "transcriptionEnabled": "Включить транскрибацию видео Gemini",
        "transcriptionModel": "Модель транскрибации",
        "transcriptionRequestTimeoutSec": "Таймаут транскрибации (с)",
        "veoResolution": "Разрешение Veo",
        "resolution720p": "720p",
        "resolution1080p": "1080p"
      },
      "byteplusBilling": {
        "title": "Биллинг (ModelArk)",
        "hint": "AK/SK нужны для API usage и счетов (fallback: asset-ключи на этом подключении). Остаток resource pack опционален — без него показываем только расход. Для оплаты по факту выберите Pay as you go.",
        "billingMode": "Режим биллинга",
        "modeResourcePack": "Resource pack (токены)",
        "modePayAsYouGo": "Pay as you go (USD)",
        "packRemainingTokens": "Остаток пакета (токены, опционально)",
        "packRemainingPlaceholder": "Если знаете остаток из Console — для оценки «сколько осталось»",
        "packTotalTokens": "Всего в пакете (опционально)",
        "projectName": "Имя проекта ModelArk",
        "region": "Регион API",
        "assetCredentialsTitle": "Access Key ID + Secret Access Key (опционально)",
        "assetCredentialsHint": "Нужны только для usage/billing и asset/admin API. Генерация ModelArk использует API key из блока «Ключи».",
        "accessKeyId": "Access Key ID",
        "secretAccessKey": "Secret Access Key",
        "resourcePacksLink": "Документация resource packs",
        "monitoringLink": "Мониторинг ModelArk"
      },
      "hints": {
        "testUsesSaved": "Запрос использует сохранённые URL и учётные данные. Сохраните изменения перед тестом.",
        "kling": {
          "authMode": "Новые ключи Kling — один API Key. Старые аккаунты могут использовать пару Access Key + Secret Key.",
          "test": "Каждый тест создаёт реальную задачу Kling. Частые клики дают HTTP 429 — подождите несколько минут."
        },
        "openrouter": {
          "apiKeyPlaceholder": "sk-or-… с openrouter.ai/keys",
          "test": "Реальный запрос к выбранной модели через OpenRouter. Сначала сохраните ключ."
        },
        "wan": {
          "apiKeyPlaceholder": "sk-… из консоли Model Studio",
          "getRetries": "Повторы только для опроса статуса (GET), не для создания задачи (POST) — чтобы не дублировать задачи в WAN.",
          "test": "Создаёт реальную задачу в Alibaba Model Studio. Не жмите часто — учитывайте квоту и стоимость."
        },
        "byteplus_seedance": {
          "apiKeyPlaceholder": "ARK API key из BytePlus ModelArk",
          "assetLibrary": "Отдельные AK/SK (SigV4) для подписи запросов. Регистрация персонажей и образов как virtual assets Seedance."
        },
        "google_ai_studio": {
          "docs": "Документация: ai.google.dev/gemini-api. Ключ и base URL — из Google AI Studio; заголовок x-goog-api-key.",
          "apiKeyPlaceholder": "Ключ из Google AI Studio",
          "testGemini": "Реальный generateContent; учитывайте квоту. Сначала сохраните ключ."
        },
        "n8n_chatgpt": {
          "postJson": "POST JSON: prompt, system_prompt. Заголовок: Bearer (custom) или Authorization: Bearer."
        },
        "n8n_prompt_improver": {
          "postJson": "POST JSON: prompt (исходный текст), system_prompt (целевая модель). Ответ — улучшенный промпт."
        },
        "n8n_gpt_image": {
          "requestBody": "Тело: system_prompt, prompt, aspect_ratio (напр. 9:16). Токен и режим авторизации — общие с ChatGPT-подключением.",
          "test": "Нужен хотя бы один кадр в БД. Сначала сохраните URL и токен."
        },
        "dashscope": {
          "storyboardApiKey": "Пусто — используется WAN-ключ с этого подключения.",
          "test": "Реальный запрос к выбранной модели; не жмите часто из-за квоты и стоимости."
        },
        "topaz": {
          "apiKey": "Передаётся как X-API-Key. Значение шифруется и не возвращается в браузер.",
          "retry": "В документации Topaz рекомендуют retry после HTTP 429 с backoff. Для upload/status-вызовов.",
          "noTest": "Кнопки теста пока нет: quickstart создаёт реальный запрос и требует загрузки видео."
        },
        "cloud": {
          "apiKey": "Заголовок X-API-KEY. Пусто — если на сервере аутентификация выключена.",
          "baseUrl": "http://127.0.0.1:8080 — заглушка. Укажите адрес сервера."
        },
        "outbound_proxy": {
          "intro": "HTTP или HTTPS proxy (CONNECT для исходящего HTTPS). В проде с Kamal accessory sing-box обычно http://sing-box:7890."
        }
      }
    }
  },
  "generationSkills": {
    "headTitle": "Скиллы",
    "studioTitle": "Системные скиллы",
    "companyTitle": "Скиллы компании",
    "listTitle": "Скиллы",
    "selectHint": "Выберите скилл слева, чтобы открыть карточку.",
    "empty": "Пока нет скиллов.",
    "filterPlaceholder": "Поиск скиллов…",
    "filterEmpty": "Нет скиллов по фильтру.",
    "clearFilter": "Сбросить поиск",
    "levels": {
      "project": "Проект",
      "company": "Компания",
      "system": "Системные"
    },
    "add": "Добавить",
    "nameLabel": "Название",
    "descriptionLabel": "Описание",
    "descriptionPlaceholder": "Краткое описание для библиотеки скиллов",
    "slugLabel": "Короткое имя",
    "slugHint": "В чате агента: /короткое-имя. Латиница, цифры, дефисы.",
    "bodyLabel": "Текст скилла",
    "bodyPlaceholder": "Опишите, как должен вести себя ассистент для этого скилла.",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Сохранено",
    "saveFailed": "Не удалось сохранить",
    "delete": "Удалить",
    "deleteConfirmTitle": "Удалить скилл «{{name}}»?",
    "deleteConfirmMessage": "Это действие нельзя отменить.",
    "destroyBlocked": "Скилл используется в назначениях",
    "activeLabel": "Активен",
    "fileToSkillUpload": "Загрузить скилл",
    "fileToSkillHint": "Модель перепишет документ в скилл: короткое название и описание на русском, тело — сжатые рабочие инструкции для ассистента, не дословный текст файла. Результат сразу сохранится в этот скилл.",
    "fileToSkillFormats": "Форматы: .txt, .md (макс. ~100k токенов / 400k символов, ~1.5 МБ).",
    "fileToSkillDropHint": "Перетащите файл сюда или выберите",
    "fileToSkillBadFormat": "Поддерживаются только файлы .txt и .md",
    "fileToSkillUploading": "Загрузка…",
    "fileToSkillQueued": "В очереди…",
    "fileToSkillProcessing": "Генерируем скилл…",
    "fileToSkillFailed": "Не удалось создать скилл из файла",
    "fileToSkillSaveStuck": "Скилл сгенерирован, но не сохранился. Попробуйте ещё раз.",
    "fileImportModeConvert": "Преобразовать",
    "fileImportModeDirect": "Как есть",
    "fileImportDirectHint": "Загрузите готовый скилл .txt или .md. YAML frontmatter (name, description) опционален; иначе весь файл станет текстом скилла, имя — из файла.",
    "fileImportSaved": "Скилл загружен из файла.",
    "assignmentsTitle": "Назначения",
    "assignmentsNav": "Назначения скиллов",
    "discussTab": "Обсудить",
    "editTab": "Редактировать",
    "assignmentsHint": "Скиллы с верхних уровней дополняются нижними. Порядок внутри уровня сохраняется при применении.",
    "addSkill": "Добавить скилл",
    "newSkillName": "Новый скилл",
    "layerSystem": "Системный",
    "layerCompany": "Компания",
    "sectionOther": "Другое",
    "sectionNone": "Без раздела",
    "sectionLabel": "Раздел",
    "sectionEmpty": "Нет скиллов",
    "addSection": "Добавить раздел",
    "renameSection": "Переименовать",
    "renameSectionPrompt": "Название раздела",
    "deleteSection": "Удалить",
    "deleteSectionConfirmTitle": "Удалить раздел «{{name}}»?",
    "deleteSectionConfirmMessage": "Скиллы останутся без раздела. Это действие нельзя отменить.",
    "dragReorder": "Перетащить для смены порядка",
    "removeSkill": "Убрать",
    "loading": "Загрузка скиллов…",
    "loadFailed": "Не удалось загрузить скиллы",
    "groups": {
      "assistants": "Ассистенты",
      "vision": "Визуальный анализ"
    },
    "usageContexts": {
      "shots_assistant": "Обзор / Раскадровка",
      "characters_assistant": "Герои",
      "locations_assistant": "Локации",
      "props_assistant": "Реквизит",
      "canvas_assistant": "Холст",
      "flow_assistant": "Флоу",
      "skills_discussion_assistant": "Скиллы: обсудить",
      "skills_editor_assistant": "Скиллы: редактировать",
      "skills_assistant": "Скиллы",
      "script_assistant": "Сценарий",
      "projects_assistant": "Проекты студии",
      "scene3d_assistant": "3D-сцены",
      "vision_image": "Изображения",
      "vision_video": "Видео"
    },
    "fileToSkillSaved": "Скилл сохранён из файла.",
    "readonlyInheritedHint": "Этот унаследованный скилл открыт для просмотра. Чтобы сохранить правки, переключитесь на свой уровень.",
    "platformContentHiddenHint": "Содержимое платформенного скила доступно только администратору платформы."
  }
}
